import { useAds } from '@/context/AdContext';
import AdCode from './AdCode';

const AdSpace = ({ size = 'medium', type = 'default', className = '', customCode = null }) => {
  const { adSettings } = useAds();

  // Determine which ad code to use based on type
  const getAdCode = () => {
    if (customCode) return customCode;
    
    switch (type) {
      case 'header':
        return adSettings?.header_ad_code;
      case 'sidebar':
        return adSettings?.sidebar_ad_code;
      case 'footer':
        return adSettings?.footer_ad_code;
      default:
        return adSettings?.sidebar_ad_code || adSettings?.header_ad_code;
    }
  };

  const adCode = getAdCode();

  // Only render if there's an ad code - no placeholder
  if (!adCode) {
    return null;
  }

  return (
    <div className={`${className}`} data-testid={`ad-space-${type || size}`}>
      <AdCode code={adCode} />
    </div>
  );
};

export default AdSpace;
